import React, { useMemo, type HTMLAttributes } from 'react';
import type { RequestOptions } from 'searchkit';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, Text } from '@uncinc/uncinc-react-kitchen-sink';

import type {
  ParagraphContentOverview as Type,
} from '../../../../types/uncinc_profile/paragraphs';

import {
  constructQuery,
  constructAdditionalOverviewFilters,
} from '../../../../components/Search/MetaSearch/metaParagraphsHelpers';
import MetaSearch from '../../../../components/Search/MetaSearch';

import './style.scss';

interface ParagraphContentOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphContentOverview: React.FC<ParagraphContentOverviewProps> = ({
  id,
  entity,
}) => {
  const contentOverview = entity.toJS();
  const contentType = contentOverview.field_content_type[0].value;
  const langcode = contentOverview.langcode[0].value;

  const title = contentOverview.field_title[0]?.value;
  const body = contentOverview.field_body[0]?.processed || '';

  const requestOptions: RequestOptions = {
    getBaseFilters: () => [
      constructQuery(contentType, langcode),
      constructAdditionalOverviewFilters(contentOverview),
    ],
  };

  // If no filter fields have more than one value,
  // it's no use showing facets.
  // TODO: Dynamic Facet options so we show only Facets that have
  // more than one option.
  const withFacets = useMemo(() => (
    contentOverview.field_article_types.length > 1 &&
    contentOverview.field_project_statuses.length > 1 &&
    contentOverview.field_project_types.length > 1 &&
    contentOverview.field_labels.length > 1
  ), [contentOverview]);

  const classNames = c(
    'Paragraph',
    'ParagraphMeta',
    'ParagraphContentOverview',
    `ParagraphContentOverview--${contentType}`,
  );

  return (
    <div id={id} className={classNames}>
      <Container>
        <div className="row">
          <div className="col-12">
            {(title || body) && (
              <div className="ParagraphContentOverview__body">
                <Text
                  title={title}
                  text={body}
                />
              </div>
            )}

            <MetaSearch
              requestOptions={requestOptions}
              contentType={contentType}
              hitsPerPage={12}
              withFacets={withFacets}
              withPagination
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphContentOverview;
